export default {
    light: {
      //primary: "#136ebf",
      primary: "#234F9F",
      //secondary: "#9013FE",
      secondary: "#D29E4A",
      error: "#F44336",
      warning: "#FF9800",
      success: "#4CAF50",
      //info: "#00aec9",
      info: "#D29E4A",
      textColor: "#333333",
      iconColor: "#37474F",
      grayBold: '#4a4a4a'
  }
};

